import "react";
import { Box, Button, Link, Text } from "@opendoor/bricks-next";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
//#region src/platform/auth/CheckEmailForm.tsx
var CheckEmailForm = ({ hasGeneratedPassword, email, analyticsName, onResetValidEmail, requestResetPassword }) => {
	const headerText = hasGeneratedPassword ? "Set up your account" : "Check your email", emailInstructionText = hasGeneratedPassword ? `First, check your email and click the link to set up your password. We emailed a link to ${email}.` : `We’ve sent reset password instructions to ${email}. Once you’ve reset your password, sign in again.`;
	return /* @__PURE__ */ jsxs(Box, {
		gap: "$20x",
		children: [/* @__PURE__ */ jsxs(Box, {
			gap: "$10x",
			children: [/* @__PURE__ */ jsx(Text, {
				tag: "h2",
				typography: "$headerMedium",
				children: headerText
			}), /* @__PURE__ */ jsx(Text, {
				tag: "p",
				typography: "$bodySmall",
				children: emailInstructionText
			})]
		}), hasGeneratedPassword ? /* @__PURE__ */ jsxs(Fragment, { children: [requestResetPassword && /* @__PURE__ */ jsx(Button, {
			variant: "primary",
			size: "small",
			label: "Resend email",
			onPress: () => requestResetPassword(email),
			analyticsName: `${analyticsName}-resend-reset-password-email`,
			"aria-label": "Resend email"
		}), /* @__PURE__ */ jsxs(Text, {
			tag: "p",
			typography: "$bodyMedium",
			children: [
				"We’ve sent reset password instructions to ",
				email,
				". Once you’ve reset your password,",
				" ",
				/* @__PURE__ */ jsx(Link, {
					variant: "primary",
					href: "/login",
					size: "medium",
					onPress: onResetValidEmail,
					analyticsName: `${analyticsName}-sign-in-after-reset-password`,
					"aria-label": "Sign In",
					"data-testid": "sign-in-after-reset-password",
					children: "sign in again"
				})
			]
		})] }) : /* @__PURE__ */ jsx(Button, {
			variant: "primary",
			size: "small",
			label: "Sign In",
			onPress: onResetValidEmail,
			analyticsName: `${analyticsName}-sign-in-after-reset-password`,
			"aria-label": "Sign In",
			"data-testid": "sign-in-after-reset-password"
		})]
	});
};
//#endregion
export { CheckEmailForm as default };

//# sourceMappingURL=CheckEmailForm.mjs.map